import React, { useEffect, useState } from "react";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { toggleRightSidebar } from "../../store/actions";
import toastr from "toastr";
import "toastr/build/toastr.min.css"; 
import { Link } from "react-router-dom";
import logo from "../../assets/images/logosm.svg";

function Header({ toggleMenuCallback, toggleRightSidebar, t }) {
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const [isSocialPf, setIsSocialPf] = useState(false);


  const toggleFullscreen = () => {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  };

  return (
    <>
      <header id="page-topbar">
        <div className="navbar-header d-flex justify-content-between align-items-center">
          <div className="d-flex">
            {/* <button
              type="button"
              className="btn btn-sm px-3 font-size-24 header-item"
              id="vertical-menu-btn"
              onClick={toggleMenuCallback}
            >
              <i className="ri-menu-2-line align-middle"></i>
            </button> */}
            <div className="px-3 py-3">
              <Link to="/" className="logo d-inline-block">
                  <span className="logo-lg">
                    <img src={logo} alt="" height="64" />
                  </span>
              </Link>
            </div>
            <p className="m-0 text-gray-500 py-3 px-3 font-size-14 font-family-Urbanist d-none d-sm-block">
                <strong className="font-size-24 ">
                  {t("greeting", { name: authUser?.user?.name || "Admin" })}
                </strong>
                <br />
                {t("garageMessage")}
              </p>
          </div>
          {/* <div className="d-flex app-search-wrap">
             <form className="app-search d-none d-lg-block ">
              <div className="position-relative">
                <input type="text" className="form-control" placeholder="Search..." />
                <span className="ri-search-line"></span>
              </div>
            </form>
          </div> */}
          <div className="d-flex align-items-center gap-2">
            <div className="dropdown">
           
              <div
                className={`dropdown-menu dropdown-menu-lg dropdown-menu-end${
                  isSocialPf ? " show" : ""
                }`}
                aria-labelledby="socialDropdown"
              >
                <div className="row g-0 px-lg-2">
                  {/* Add your dropdown links/icons here */}
                </div>
              </div>
            </div>

            <Link
              className="btn btn-sm btn-primary"
              to={"/add-sale"}
            >
              <i className="mdi mdi-plus font-size-20"></i>
            </Link>
            <button
              type="button"
              className="btn header-item noti-icon waves-effect"
              onClick={toggleFullscreen}
            >
              <i className="ri-fullscreen-line"></i>
            </button>

            {/* <NotificationDropdown /> */}
            <ProfileMenu />
          </div>
        </div>
      </header>
    </>
  );
}

export default connect(null, { toggleRightSidebar })(withTranslation()(Header));
